<template>
  <div class="content">
    <shipments-table 
      :shipments="localShipments"
      :loading="fetchingShipments"
      :shipment-status="localStatuses"
      @filters-updated="handleFiltersUpdated" 
      :current-page="currentPage"
      :last-page="lastPage"
      :per-page="perPage"
      :total="total"
    />
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import axios from 'axios'

// Props
const props = defineProps({
  shipments: Array,
  shipmentStatus: Array,
})

// Reactive state
const fetchingShipments = ref(false)
const total = ref(0)
const currentPage = ref(1)
const lastPage = ref(1)
const perPage = ref(100)
const activeFilters = ref({}) // Track all active filters

// Local state
const localShipments = ref([...props.shipments ?? []])
const localStatuses = ref([...props.shipmentStatus ?? []])

// Fetch data whenever filters change
watch(activeFilters, (newFilters) => {
  fetchShipments(newFilters)
}, { deep: true })

function getCSRFToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
}

function cleanFilters(filters) {
  const cleaned = { ...filters }
  Object.keys(cleaned).forEach(key => {
    if (cleaned[key] === null || 
        cleaned[key] === '' ||
        (Array.isArray(cleaned[key]) && cleaned[key].length === 0)) {
      delete cleaned[key]
    }
  })
  return cleaned
}

function handleFiltersUpdated(filters) {
  // Always update page and perPage from filters
  if (filters.page !== undefined) {
    currentPage.value = filters.page
  }
  if (filters.perPage !== undefined) {
    perPage.value = filters.perPage
  }
  
  // Merge new filters with existing ones
  activeFilters.value = {
    ...activeFilters.value,
    ...filters,
    page: currentPage.value,
    perPage: perPage.value
  }
}

async function fetchShipments(filters = {}) {
  if (window.One) window.One.layout('header_loader_on')
  fetchingShipments.value = true

  try {
    const response = await axios.post('/shipments/get-pickup-request-shipments',
      cleanFilters({
        ...filters,
        page: currentPage.value,
        perPage: perPage.value
      }),
      {
        headers: {
          'X-CSRF-TOKEN': getCSRFToken(),
          'Content-Type': 'application/json'
        }
      }
    )

    // Update state from response
    localShipments.value = response.data.data
    total.value = response.data.total
    currentPage.value = response.data.current_page
    lastPage.value = response.data.last_page
    perPage.value = response.data.per_page

  } catch (error) {
    console.error('Error fetching shipments:', error)
  } finally {
    fetchingShipments.value = false
    if (window.One) window.One.layout('header_loader_off')
  }
}

async function fetchStatuses(ids = []) {
  try {
    const response = await axios.post('/get-shipments-status',
      { ids },
      {
        headers: {
          'X-CSRF-TOKEN': getCSRFToken(),
          'Content-Type': 'application/json'
        }
      }
    )
    localStatuses.value = response.data
  } catch (error) {
    console.error('Error fetching statuses:', error)
  }
}

onMounted(() => {
  fetchShipments()
  fetchStatuses(["1", "2"])  // Example IDs to fetch statuses for
  })
</script>